<template>
  <div>
    <div class="title">
      IOT平台
      <!-- <template v-if="item.status === 0">
                      <span class="status status0">审核中</span>
                    </template>
                    <template v-if="item.status === 1">
                      <span class="status status1">通过</span>
                    </template>
                    <template v-if="item.status === 2">
                      <span class="status status2">不通过</span>
                    </template> -->
    </div>
    <div class="content">
        <div class="pageList">
          <div class="mainItemTit">
            {{data.title}}
          </div>
            <div class="list">
              <template v-if="data && data.title">
                <div class="mainItemBlock">
                <div class="mainItemContent">
                  <div class="mainItemLeft">
                    <!-- <el-row class="myLine">
                      <el-col :span="12">
                        <label>应用主页</label>
                        <span>{{data.loginUrl}} </span>
                      </el-col>
                      <el-col :span="12">
                        <label>应用回调地址</label>
                        <span>{{data.mainUrl}}</span>
                      </el-col>
                    </el-row>
                    <el-row class="myLine">
                      <el-col :span="12">
                        <label>clientId</label>
                        <span>{{data.clientId}} </span>
                      </el-col>
                      <el-col :span="12">
                        <label>clientSecret</label>
                        <span>{{data.clientSecret}}</span>
                      </el-col>
                    </el-row> -->
                    <el-row class="myLine">
                      <el-col :span="12">
                        <label>创建时间</label>
                        <span>{{data.createTime}} </span>
                      </el-col>
                      <el-col :span="12">
                        <label>授权时间</label>
                        <span>{{data.authTime}}</span>
                      </el-col>
                    </el-row>
                    <el-row class="myLine">
                      <el-col :span="24">
                        <label>应用描述</label>
                        <span class="longSpan">{{data.describe}}</span>
                      </el-col>
                    </el-row>

                    <div class="mainBottom">
                      <div class="btn">
                          <a :href="data.linkUrl ? data.linkUrl : ''" target="_blank">
                          <div>跳转后台</div>
                          <img src="../../assets/images/rightArrow.png" alt="">
                          </a>
                        </div>
                    </div>
                  </div>
                  <div class="mainItemRight">
                    <img src="../../assets/images/iotImg.png" />
                  </div>
                </div>
                
              </div>
              </template>
              <template v-else>
                <div class="noData">
                  <img src="../../assets/images/zwsj@2x.png" />
                  <div>暂无数据</div>
                </div>
              </template>

              <!-- <div class="listItem">
              <div class="pageTitle">
                    <span class="name">{{data.title}}</span>
                    
                    <div class="btn" v-if="data.authStatus == 1">
                      <a :href="data.linkUrl ? data.linkUrl : ''" target="_blank">
                      <div>跳转应用</div>
                      <img src="../../assets/images/rightArrow.png" alt="">
                      </a>
                    </div>
              </div>

             <div class="pageContent">
                <div class="ts">
                  <span class="label">平台描述</span>
                  <span>{{data.describe}}</span>
                </div>
             </div>
            
            </div> -->
            </div>
            <!-- <div class="pageBox">
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="pageNum"
                    :page-size="pageSize"
                    layout="total, sizes, prev, pager, next"
                    :total="total">
                </el-pagination>
            </div> -->
        </div>
    </div>

  </div>
</template>

<script>
  import { fetchIotIntroduce } from "@/api/api"
  export default {
    data() {
      return {
        total: 0,
        pageNum: 1,
        pageSize: 10,
        list: [],
        loading: false,
        data: null
      }
    },
    created() {
      this.getIotInfo()
    },
    methods: {
      getIotInfo() {
        fetchIotIntroduce().then(res => {
          this.data = res.data
        })
      }
      // handleSizeChange(val) {
      //   this.pageSize = val
      //   this.getList()
      // },
      // handleCurrentChange(val) {
      //   this.pageNum = val
      //   this.getList()
      // },
      // getList() {
      //   let params = {
      //     page: this.pageNum - 1,
      //     size: this.pageSize
      //   }
      //   fetchUserAppList(params).then(res => {
      //     this.list = res.data.content
      //     this.total = Number(res.data.totalElements)
      //   })
      // }
    }
  }
</script>

<style scoped>
  .title {
    height: 66px;
    line-height: 66px;
    font-size: 20px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #282F3D;
    padding-left: 30px;
    background: #fff;
  }

  .content {
    box-sizing: border-box;
    padding: 10px 20px;
  }

  .pageList {
    width: 100%;
    height: calc(100vh - 230px);
    background: #FFFFFF;
    box-shadow: 1px 3px 16px 0px rgba(204, 211, 228, 0.51);
    border-radius: 8px;
    box-sizing: border-box;
    padding: 20px 40px;;
  }

  .list{
    height: calc(100vh - 300px);
    overflow-y: scroll;
  }
  .list::-webkit-scrollbar{
    width: 0!important;
  }

  .listItem {
    padding: 10px 0;
    border-bottom: 1px solid #E8EBF4;
    position: relative;
  }

  .status {
    background: rgba(34,94,253,0.1);
    border: 1px solid #225EFD;
    border-radius: 22px;
    font-size: 12px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #225EFD;
    text-align: center;
    padding: 3px 15px;
    margin-left: 10px;
  }
  .status0{

  }
  .status1{
    background: rgba(13,193,110,0.1);
    color: #29C87E;
    border: 1px solid #0DC16E;
  }
  .status2{
    background: rgba(255,111,5,0.1);
    color: #FF8D3A;
    border: 1px solid #FF8D3A;
  }

  .pageTitle {
    padding: 15px 0;
  }

  .pageContent {
    padding: 15px 0 0;
    display: flex;
    justify-content: flex-start;
  }

  .pageContent > div {
    width: 50%;
  }
  .pageContent > div.ts{
      width: 85%;
  }
  .pageContent .label{
      color: rgba(144, 157, 177, 1);
      padding-right: 20px;
      min-width: 80px;
      padding-right: 20px;
  }
  /* .btn {
    width: 135px;
    height: 43px;
    border: 1px solid #0F5EFF;
    border-radius: 21px;
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    right: 20px;
    bottom: 20px;
    cursor: pointer;
  }

  .btn a {
    display: block;
    width: 100%;
    display: flex;
    justify-content: center;
  }
  .btn img {
    margin-top: 3px;
    margin-left: 5px;
  }

  .btn  div {
    font-size: 16px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #0F5EFF;
    text-align: center;
  } */

.mainItemTit{
    font-size: 18px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #121E30;
    padding-bottom: 20px;
  }
  .mainItemContent{
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }
  .mainItemContent .mainItemLeft{
     flex: 1;
     border-right: 1px dashed #BCC6DF;
     padding-right: 60px;
  }
  .mainItemContent .mainItemRight{
    width: 388px;
    padding-left: 70px;
  }
  .mainItemRight{
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .mainItemContent .mainItemRight img{
    width: 350px;
  }
  .myLine{
    margin-bottom: 20px;
  }
  .myLine label{
    font-size: 16px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #909DB1;
    padding-right: 32px;
    vertical-align: top;
  }
  .myLine span{
    font-size: 16px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #121E30;
    word-break: break-all;
    display: inline-block;
    vertical-align: top;
    width: 70%;
    /* border: 1px solid #f00; */
  }
  .myLine .longSpan {
    width: 85%;
  }
  .btn {
    width: 135px;
    height: 43px;
    border: 1px solid #0F5EFF;
    border-radius: 21px;
    display: flex;
    align-items: center;
    justify-content: center;
    /* position: absolute;
    right: 20px;
    bottom: 20px; */
    cursor: pointer;
    margin-left: 100px;
  }

  .btn a {
    display: block;
    width: 100%;
    display: flex;
    justify-content: center;
  }
  .btn img {
    margin-top: 3px;
    margin-left: 5px;
  }

  .btn  div {
    font-size: 16px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #0F5EFF;
    text-align: center;
  }
 
 .noData{
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 100%;
  align-items: center;  
}
.noData img{
  width: 211px;
  height: 180px;
  margin-bottom: 20px;
}
.noData{
  font-size: 16px;
  font-family: SourceHanSansCN-Regular, SourceHanSansCN;
  font-weight: 400;
  color: #A8ADB9;
}
</style>



// WEBPACK FOOTER //
// src/views/console/IOT.vue